import {
  darkModeCardBackgroundColor,
  darkModeTextColor,
} from "constants/colors";
import styled from "styled-components/macro";
import {
  NAV_HEIGHT_PX,
  FONT_SIZE_LARGE,
  BREAKPOINT_TABLET,
} from "../../../../../constants/constants";

const FULL_PAGE_MAX_WIDTH = `calc(100vw - ${NAV_HEIGHT_PX}px)`;

export const PnlChartPopupStyles = styled.div<{
  $isDarkMode: boolean;
  $isModalOpen: boolean;
  $isHalfWidth: boolean;
  $isTimelinePage: boolean;
  $isTrendsPage: boolean;
  $isFullPagePopup: boolean;
  $isHubletPageTabletOrSmaller: boolean;
  $width: number;
  $isIe11: boolean;
  $maxHeight: number | string;
  $isGridLayoutPage: boolean;
}>`
  pointer-events: ${props => (props.$isModalOpen ? "auto" : "none")};
  [class*="PnlPopupTitleBarStyles"] {
    position: relative;
  }
  display: flex;
  flex-direction: column;
  color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
  background: ${({ $isDarkMode }) =>
    $isDarkMode ? darkModeCardBackgroundColor : "white"};
  max-width: ${props =>
    props.$isFullPagePopup
      ? FULL_PAGE_MAX_WIDTH
      : props.$width -
        /* use NAV_HEIGHT_PX to get even spacing on the top and sides */
        NAV_HEIGHT_PX +
        "px"};
  /* ie11 can't do max-height + overflow: hidden */
  ${props =>
    (props.$isIe11 ? "" : "max-") + "height: " + props.$maxHeight + ";"}
  margin: ${0.5 * NAV_HEIGHT_PX}px auto;
  margin-top: ${props =>
    (props.$isFullPagePopup ? 1.5 : props.$isGridLayoutPage ? 0.5 : 1) *
    NAV_HEIGHT_PX}px;
  border-radius: 4px;
  .content {
    box-sizing: border-box;
    padding: 4px 24px 24px;
    overflow: auto;
  }

  [class*="PnlCategoryAndTagBarsStyles"] {
    max-width: 85%;
  }

  @media (min-width: ${BREAKPOINT_TABLET}px) {
    .content {
      padding: 4px 72px 56px;
    }
    .dateTime {
      font-size: ${FONT_SIZE_LARGE}px;
    }
  }
`;
